export default "__VITE_ASSET__BQyOIPq6__"